/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './main';

// Frame-buster. X-Frame-Options / CSP frame-ancestors would be strictly better,
// but Bun's HTMLBundle routes cannot set response headers and frame-ancestors is
// ignored in a meta tag, so this is the in-app option.
// ponytail: an attacker who frames us with sandbox="allow-scripts" (and without
// allow-top-navigation) defeats this silently. Prebuild the page with `bun build`
// and serve it from a normal handler if you want the real header.
if (window.top !== window.self) {
  window.top!.location.replace(window.self.location.href);
}

const elem = document.getElementById('root')!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
